import { Connection } from '@solana/web3.js';

let connectionSingleton: Connection | null = null;

export const getConnection = () => {
  if (!connectionSingleton)
    connectionSingleton = new Connection(import.meta.env.VITE_PORTFOLIO_SOLANA_RPC ||
    'https://api.mainnet-beta.solana.com', "confirmed")
  return connectionSingleton
}
